import CONSTANTS from './constants';

export const setLocalActiveClass = (page) => {
  localStorage.setItem("menuActiveitem", page);
  localStorage.setItem("MainActiveClass", "");
};
export const setFilledFlags = (key, flag) => {
  localStorage.setItem(key, JSON.stringify(flag));
};

export const twoDigitNumber = (myNumber) => {
  return ("0" + myNumber).slice(-2);
}
export const checkForHistoryParam = (location, paramName) => {
  if (location != undefined) {
    return location[paramName]
  } else {
    return false
  }
}

export const checkForHistoryPushParam = (location, paramName) => {
  if (location != undefined) {
    return location[paramName]
  } else {
    return localStorage.getItem(paramName)
  }

}

export const getFormDataObject = (params) => {
  let data = new FormData()
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      const element = params[key];
      data.append(key, element)
    }
  }
  return data
}
export const setStoredData = (key, value) => {
  try {
    localStorage.setItem(key, value)
  } catch (error) {
    console.log("error", error)
  }
}

export function getStoredData(key) {
  try {
    let data = localStorage.getItem(key);
    return data
  } catch (error) {
    console.log("error", error)
  }
}